// Figgo – Einstellung (an/aus, localStorage, Standard an) und ein schlanker Signal-Kanal,
// über den Seiten der Pille Ereignisse melden (Suche, Telefon, Meldungen, Chat).
import { useSyncExternalStore } from 'react';
import type { FiggoEreignis } from '../../lib/figgo/scenes';

const SCHLUESSEL = 'pille.figgo';
const hoerer = new Set<() => void>();

function lesen(): boolean {
  try { return localStorage.getItem(SCHLUESSEL) !== 'aus'; } catch { return true; }
}

export function setzeFiggoAn(an: boolean): void {
  try { localStorage.setItem(SCHLUESSEL, an ? 'an' : 'aus'); } catch { /* privat/gesperrt – bleibt Standard */ }
  hoerer.forEach(h => h());
}

/** Figgo eingeschaltet? (Einstellung unten auf der Widgets-Seite) */
export function useFiggoAn(): boolean {
  return useSyncExternalStore(
    (h) => { hoerer.add(h); window.addEventListener('storage', h); return () => { hoerer.delete(h); window.removeEventListener('storage', h); }; },
    lesen,
    () => true,
  );
}

export interface FiggoSignalOptionen { force?: boolean; p?: number; cool?: number }
type Empfaenger = (kind: FiggoEreignis, o: FiggoSignalOptionen) => void;
const empfaenger = new Set<Empfaenger>();

/** Ereignis an Figgo melden (ohne Wirkung, wenn er aus ist oder nicht gerendert wird). */
export function figgoSignal(kind: FiggoEreignis, o: FiggoSignalOptionen = {}): void {
  empfaenger.forEach(e => e(kind, o));
}

export function aufFiggoSignal(e: Empfaenger): () => void {
  empfaenger.add(e);
  return () => { empfaenger.delete(e); };
}
